 var swiper = new Swiper(".category-box-inner", {
  slidesPerView: 4,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  loop:true,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-button-nextess',
    prevEl: '.swiper-button-prevess',
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    580: {
      slidesPerView: 2,
      spaceBetween: 30
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  }
});